// Formatted WhatsApp / social share messages for packages, itineraries, and
// landing pages. WhatsApp renders *bold* with single asterisks and ~strikethrough~
// with single tildes — we lean on that so the message stays readable inside the
// chat while staying plain-text safe when pasted elsewhere.

const titleCase = (s) =>
  (s || '')
    .split(/[-_ ]+/)
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');

const rupee = (n) => `₹${Math.round(Number(n) || 0).toLocaleString('en-IN')}`;

const themedEmoji = (themes = []) => {
  const t = (themes || []).map((x) => String(x).toLowerCase());
  if (t.some((x) => x.includes('beach') || x.includes('honeymoon'))) return '🌊';
  if (t.some((x) => x.includes('mountain') || x.includes('adventure'))) return '🏔';
  if (t.some((x) => x.includes('family') || x.includes('pilgrimage'))) return '🛕';
  return '🌴';
};

export const buildPackageShareMessage = (pkg, url) => {
  const dest = titleCase(pkg?.destination || pkg?.title || 'travel');
  const tagline = pkg?.title || 'Your dream trip';
  const orig = Number(pkg?.price || 0);
  const offer = Number(pkg?.offer_price || 0);
  const isOffer = pkg?.offer_enabled && offer > 0 && offer < orig;
  const off = isOffer && orig > 0 ? Math.round(((orig - offer) / orig) * 100) : 0;
  const priceLine = isOffer
    ? `💰 ~${rupee(orig)}~  *${rupee(offer)}*  🔥 ${off}% OFF`
    : `💰 *${rupee(orig)}* / adult`;
  const durationLine = pkg?.duration ? `🗓 ${pkg.duration}` : '';
  const itineraryLine = pkg?.itinerary ? `📍 ${pkg.itinerary}` : '';
  const emoji = themedEmoji(pkg?.themes);
  const lines = [
    `✈️ Check this limited time ${dest} deal on Travelsera! ${emoji}`,
    ``,
    `*${tagline}*`,
    durationLine,
    itineraryLine,
    priceLine,
    ``,
    `👉 ${url}`,
  ].filter(Boolean);
  return lines.join('\n');
};

export const buildItineraryShareMessage = (it, url) => {
  const dests = Array.isArray(it?.destinations) && it.destinations.length
    ? it.destinations.map(titleCase).join(', ')
    : (it?.trip_title || 'your trip');
  const tagline = it?.trip_title || 'Your custom itinerary';
  const name = it?.customer?.name || 'there';
  const priceLine = Number(it?.total_price) > 0 ? `💰 *${rupee(it.total_price)}* total` : '';
  const lines = [
    `✈️ Check this limited time ${dests} deal on Travelsera! 🌴`,
    ``,
    `Hi ${name}, your day-wise itinerary is ready.`,
    `*${tagline}*`,
    priceLine,
    ``,
    `📄 View / download the PDF:`,
    `👉 ${url}`,
  ].filter(Boolean);
  return lines.join('\n');
};

export const buildPageShareMessage = (page, url) => {
  const title = page?.seo_title || page?.title || 'Travelsera';
  const desc = (page?.seo_description || (page?.body || '').split('\n')[0] || '').trim();
  const dest = titleCase(page?.title || 'travel');
  const lines = [
    `✈️ Check this limited time ${dest} deal on Travelsera! 🌴`,
    ``,
    `*${title}*`,
    desc,
    ``,
    `👉 ${url}`,
  ].filter(Boolean);
  return lines.join('\n');
};
